// TODO: Перенести в файл стилей
import 'swiper/css';
import '../../sections/awards';
import '../../sections/career-default';
import '../../sections/news';
import '../../sections/first-screen';
import '../../sections/future';
import '../../sections/history';
import '../../sections/info-block';
import '../../sections/infrastructure';
import '../../sections/intro-main';
import '../../sections/invest-option';
import '../../sections/persons';
import '../../sections/reviews';
import '../../sections/contacts-office';
import '../../sections/news-list';
import '../../sections/news-section';
import '../../sections/tender-actual';
import '../../sections/project/project-advantages';
import '../../sections/project/project-available';
import '../../sections/project/project-info';
import '../../sections/project/project-infrastructure';
import '../../sections/project/project-main';
import '../../sections/project/project-plan';
import '../../sections/payment-confirmation';
import '../../sections/crm-order-creation';
import '../../components/article';
import '../../components/documents-slider';
import '../../components/search-content';
import '../../components/share';
import '../../components/years';
import {closeMenu, initBurgerAction} from './modules/init-burger-action';
import {
    initCallbackForm,
    initCallbackPopup,
    initCookie,
    initForm,
    initMultiSelect,
    initPopup,
    initScrollBy,
    initScrollToTop,
    initSingleSelect,
    initSubscribePopup,
    initTabs,
    lazyLoadElements
} from './common';
import Accordion from '../../components/accordion';
import {animateProjectCard} from './modules/animate-project-card';
import DetailsAccordion from '../../components/details';
import FullScreenScroll from '../../components/fullscreen-scroll';
import {initHeaderMobile} from './modules/init-header-mobile';
import {initIntroSlider} from './modules/init-intro-slider';
import {initNavigationHover} from './modules/init-navigation-hover';
import {initProjectsListSlider} from './modules/init-projects-slider';
import {initStepsSlider} from './modules/init-steps-slider';
import Observer from './observer';
import ProjectCard from '../../components/project-card';
import {removeFocus} from './modules/remove-focus';
import {Utils} from './utils';
import Vacancy from '../../sections/career-vacancy';

const observer = new Observer();

const homepage = document.querySelector('.j-home-slider');

if (homepage) {
    const fullScreenScroll = new FullScreenScroll();

    fullScreenScroll.init();
}

// Details Accordion
const details = document.querySelectorAll('.j-details');

if (details.length) {
    details.forEach((element) => {
        const accordion = new DetailsAccordion();

        accordion.init({
            element
        });
    });
}

// Формы
const formWrappers = Array.from(document.querySelectorAll('.j-form'));

if (formWrappers.length) {
    initCallbackForm();
    formWrappers.forEach((wrapper) => {
        initForm(wrapper);
    });
}

// Попапы
const popupSelectors = Array.from(document.querySelectorAll('.j-popup'));

if (popupSelectors.length) {
    initPopup(popupSelectors, {removeDelay: 300});
}

// Текстовые попапы
const popupTexts = Array.from(document.querySelectorAll('.j-popup-text'));

if (popupTexts.length) {
    initPopup(popupTexts, {modify: 'popup_theme_text'});
}

// Отдельный селектор для попапов обратных звонков
const popupFacadeLinks = Array.from(document.querySelectorAll('.j-popup-callback'));

if (popupFacadeLinks.length) {
    initCallbackPopup(popupFacadeLinks);
}

// Отдельный селектор для попапов загрузка документов (страница тендеры)
const popupTenderQuestionary = Array.from(document.querySelectorAll('.j-popup-callback-tender-questionary'));

if (popupTenderQuestionary.length) {
    const options = {
        removeDelay         : 300,
        closeButtonAriaLabel: 'Закрыть форму обратного звонка',
        modify              : 'popup_theme_tenders',
        onCreate() {
            // TODO Мультипопап.
            // Получаем контекст this из popup.js (через popupFacade.js)
            const popupContent = this?.content;

            if (popupContent && this.removePopup) {
                const innerPopupButtons = Array.from(popupContent.querySelectorAll('[data-href]'));

                if (innerPopupButtons.length) {
                    // Далее инитим внутренние кнопки на попапы
                    initSubscribePopup(innerPopupButtons, options);

                    innerPopupButtons.forEach((button) => {
                        button.addEventListener('click', () => {
                            // Удаляем / Закрываем активный попап
                            this.removePopup();
                        });
                    });
                }
            }
        }
    };

    initSubscribePopup(popupTenderQuestionary, options);
}

// Отдельный селектор для попапов подписки
const popupSubscribes = Array.from(document.querySelectorAll('.j-popup-subscribe'));

if (popupSubscribes.length) {
    initSubscribePopup(popupSubscribes, {modify: 'popup_theme_subscribe popup_theme_callback j-form-subscribe'});
}

// Отдельный селектор для попапов линии доверия
const popupTrusts = Array.from(document.querySelectorAll('.j-popup-trust'));

if (popupTrusts.length) {
    initPopup(popupTrusts, {modify: 'popup_theme_trust'});
}

// Попапы с видео в аккордионе
const popupAccordionVideo = Array.from(document.querySelectorAll('.j-accordion-video'));

if (popupAccordionVideo.length) {
    initPopup(popupAccordionVideo, {modify: 'popup_theme_video'});
}

// Инициализация Мобильного меню
initBurgerAction();

// Ховер на пункты навигации
initNavigationHover();

// Закрывает меню при нажатии на его пункт
const menuItems = Array.from(document.querySelectorAll('.j-main-nav-item'));

if (menuItems.length) {
    menuItems.forEach((item) => {
        item.addEventListener('click', (event) => {
            if (event.target.tagName === 'A') {
                if (Array.from(event.target.getAttribute('href'))[0] === '#') {
                    observer.publish('homeSlideTo');
                }
            }

            return closeMenu();
        });
    });
}

//  Логика шапки на мобиле
initHeaderMobile();

// инициализация слайдера Проекты
initProjectsListSlider();

// анимация карточки Проекта
animateProjectCard();
// убирает фокус после клика
removeFocus();

// Инициализация Интро слайдера
const introSlider = document.querySelector('.j-intro-slider');

initIntroSlider(introSlider);

// Инициализируем аккордеон с вопросами
const questions = document.querySelector('.j-questions-accordion');

if (questions) {
    const showAll = document.querySelector('.j-questions-all');
    const questionsAccordion = new Accordion();

    questionsAccordion.init(questions);

    if (showAll) {
        showAll.addEventListener('click', () => {
            questionsAccordion.toggle();
        });
    }
}

/* Ленивая загрузка */
const lazyElements = Array.from(document.querySelectorAll('[loading=lazy]'));

if (lazyElements.length) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            lazyLoadElements(lazyElements);
        });
    } else {
        lazyLoadElements(lazyElements);
    }
}

observer.subscribe('lazyLoad:refresh', (container) => {
    const secLazyElements = Array.from(container.querySelectorAll('[loading=lazy]'));

    lazyLoadElements(secLazyElements);
});

// Якоря
const anchors = Array.from(document.querySelectorAll('.j-anchor'));

if (anchors.length) {
    initScrollBy({anchors});
}

const anchorsOffset = Array.from(document.querySelectorAll('.j-anchor-offset'));

if (anchorsOffset.length) {
    initScrollBy({
        anchors: anchorsOffset,
        offset : 50
    });
}

// Скролл наверх
const scrollToTop = document.querySelector('.j-desctop-top');

if (scrollToTop) {
    initScrollToTop(scrollToTop);
}

const projectCards = Array.from(document.querySelectorAll('.j-projects-page-card'));

projectCards.forEach((card) => {
    new ProjectCard({card}).init();
});


const projectsPopupBtns = Array.from(document.querySelectorAll('.j-project-popup'));

if (projectsPopupBtns.length) {
    initPopup(projectsPopupBtns, {modify: 'popup_theme_projects'});
}

// Кнопка назад в новостях
const historyBack = document.querySelector('.j-history-back');

if (historyBack) {
    historyBack.addEventListener('click', (event) => {
        event.preventDefault();
        history.go(-1);
    });
}

// Непопап про cookies
const cookiePopup = document.querySelector('.j-cookie');

if (cookiePopup) {
    const duration = cookiePopup.dataset.duration;

    initCookie(duration);
}

// Список вакансий
const vacancyList = document.querySelector('.j-vacancy__result');

if (vacancyList) {
    const options = {
        wrapper: vacancyList,
        url    : vacancyList.dataset.url
    };

    new Vacancy(options).init();
}


// Селекты
const singleSelects = Array.from(document.querySelectorAll('.j-single-select'));

singleSelects.forEach((select) => {
    initSingleSelect(select);
});

const multiSelects = Array.from(document.querySelectorAll('.j-multi-select'));

multiSelects.forEach((select) => {
    initMultiSelect(select);
});

// Табы
const tabs = Array.from(document.querySelectorAll('.j-tabs-wrap'));

tabs.forEach((elem) => {
    initTabs(elem);
});

// Изменение цвета шапки
const listenChangeHead = document.querySelector('.j-header-change-color');

if (listenChangeHead) {
    const activeColor = listenChangeHead.dataset.activeColor;
    const setColor = listenChangeHead.dataset.setColor;

    document.addEventListener('scroll', () => {
        if (Utils.getScrollTop() > 250) {
            listenChangeHead.classList.remove(`header_theme_${activeColor}`);
            listenChangeHead.classList.add(`header_theme_${setColor}`);
        } else {
            listenChangeHead.classList.add(`header_theme_${activeColor}`);
            listenChangeHead.classList.remove(`header_theme_${setColor}`);
        }
    });
}

const stepsSliders = document.querySelectorAll('.j-steps-slider');

stepsSliders.forEach((stepSlider) => {
    initStepsSlider(stepSlider);
});
